export function Tabs() {
  const tabsContainer = document.querySelectorAll(".tabbed-section--container")
  const activeClass = "active"

  tabsContainer.forEach((element) => {
    const tabsMenu = element.querySelector(".nav")
    const tabs = element.querySelectorAll(".nav-item")
    const tabsContent = element.querySelectorAll(".tab")
    const tabLinks = []
    const tabNames = []

    if (tabs.length > 0 && tabsContent.length > 0) {
      tabs.forEach((element, index) => {
        tabLinks[index] = tabs[index].querySelector(".nav-link")
        tabNames[index] = tabLinks[index].getAttribute("href")
      })

      tabs[0].classList.add(activeClass)
      tabLinks[0].classList.add(activeClass)
      tabsContent[0].classList.add(activeClass)

      tabLinks.forEach((element, index) => {
        element.onclick = (event) => {
          event.preventDefault()
          tabsMenu.classList.toggle(activeClass)
          tabs.forEach((element) => {
            element.classList.remove(activeClass)
          })
          tabs[index].classList.add(activeClass)
          tabLinks.forEach((element) => {
            element.classList.remove(activeClass)
          })
          tabLinks[index].classList.add(activeClass)
          tabsContent.forEach((element) => {
            element.classList.remove(activeClass)
          })
          tabsContent[index].classList.add(activeClass)
        }
      })

      const tabHash = () => {
        tabs.forEach((element, index) => {
          if (window.location.hash === tabNames[index]) {
            tabLinks.forEach((element) => {
              element.classList.remove(activeClass)
            })
            tabsContent.forEach((element) => {
              element.classList.remove(activeClass)
            })
            tabLinks[index].classList.add(activeClass)
            tabsContent[index].classList.add(activeClass)
          }
        })
      }

      tabHash()

      window.addEventListener("hashchange", () => {
        tabHash()
      })
    }
  })
}
